// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2TVDB","itemTitle":"ClientEmergencyInfo_itemTitle__3ukyi","itemText":"ClientEmergencyInfo_itemText__37vsu"};